import api from "services/api";

// Get
export const getSalaryStructures = async (queryParams = {}) => {
  return api.get("/v1/api/salary-structure/list", { params: queryParams });
};

// Create
export const createSalaryStructure = async (salaryData) => {
  return api.post("/v1/api/salary-structure/create", salaryData);
};

// Update
export const updateSalaryStructure = async (salaryStructureId, salaryData) => {
  return api.put(
    `/v1/api/salary-structure/update/${salaryStructureId}`,
    salaryData,
  );
};

// Delete
export const deleteSalaryStructure = async (salaryStructureId) => {
  return api.delete(`/v1/api/salary-structure/delete/${salaryStructureId}`);
};
